import Vue from 'vue'
import { login, getInfo, logout } from '@/api/login'
import { getBusinessTypeNodeInfo } from '@/api/sys'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { welcome } from '@/utils/util'
import userConfig from '@/config/defaultSettings'
import config from '@/utils/config'

const user = {
  state: {
    token: '',
    name: '',
    welcome: '',
    avatar: '',
    roles: '',
    info: {},
    bizCodeList: {},
    codeList: {},
    bizList: [],
    blackList: {},
    userList:[]
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, { name, welcome }) => {
      state.name = name
      state.welcome = welcome
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_INFO: (state, info) => {
      state.info = info
    },
    SET_BIZCODES: (state, bizCodeList) => {
      state.bizCodeList = bizCodeList
    },
    SET_BIZS: (state, bizList) => {
      state.bizList = bizList
    },
    SET_CODES: (state, codeList) => {
      state.codeList = codeList
    },
    SET_BLACK: (state, blackList) => {
      state.blackList = blackList
    },
    SET_USERLIST: (state, userList) => {
      state.userList = userList
    },
  },

  actions: {
    // 登录
    Login ({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo).then(response => {
          const code = response.code
          if (code === '0') {
            const token = response.data
         //   const trueName = response.data.trueName
            Vue.ls.set(ACCESS_TOKEN, token, 30 * 24 * 60 * 60 * 1000)
            commit('SET_TOKEN', token)
         //   commit('SET_NAME', { name: trueName})
          }
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo ({ commit }) {
      return new Promise((resolve, reject) => {
        console.log('刷新用户信息')
        getInfo().then(response => {
          const code = response.code
          if (code === '0') {
            const data = response.data
            commit('SET_NAME', { name: data.trueName, welcome: welcome() })
          }
          // if (result.role && result.role.permissions.length > 0) {
          //   const role = result.role
          //   role.permissions = result.role.permissions
          //   role.permissions.map(per => {
          //     if (per.actionEntitySet != null && per.actionEntitySet.length > 0) {
          //       const action = per.actionEntitySet.map(action => { return action.action })
          //       per.actionList = action
          //     }
          //   })
          //   role.permissionList = role.permissions.map(permission => { return permission.permissionId })
          //   commit('SET_ROLES', result.role)
          //   commit('SET_INFO', result)
          // } else {
          //   reject(new Error('getInfo: roles must be a non-null array !'))
          // }

          // commit('SET_AVATAR', result.avatar)
          // commit('SET_NAME', { name: data.trueName, welcome: welcome() })
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    Logout ({ commit, state }) {
      return new Promise((resolve) => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', '')
        commit('SET_TOKEN', '')
        commit('SET_NAME', '')
        logout(state.token).then(() => {
          Vue.ls.remove(ACCESS_TOKEN)
          resolve()
        }).catch((e) => {
          console.log(e)
          resolve()
        })
      })
    },

    // 获取业务类型节点信息(暂时放在user.js中)
    getBusinessTypeNodeInfo ({ commit }) {
      return new Promise((resolve, reject) => {
        getBusinessTypeNodeInfo().then(response => {
          const code = response.code
          if (code === '0') {
            let bizCodeListCache = {}
            let bizList = []
            let bizCodeList = response.data.bizCodeList
            for (let i=0;i<bizCodeList.length;i++){
              let code = bizCodeList[i]
              if ( !(bizCodeListCache[code.businessTypeId] instanceof Array) ){
                bizCodeListCache[code.businessTypeId] = []
                bizList.push({"id":code.businessTypeId, "name":code.typeName, "hasOrder":code.hasOrder})
              }
              bizCodeListCache[code.businessTypeId].push(code)
            }
            // 手动添加一个已完成状态
            /*             for (var p in bizCodeListCache){
             bizCodeListCache[p].push({"name":"已完成", "value":"999"})
             } */
            commit('SET_BIZCODES', bizCodeListCache)
            commit('SET_BIZS', bizList)


            let allCodeList = {}
            let codeList = response.data.codeList
            for (let i=0;i<codeList.length;i++){
              let code = codeList[i]
              if ( !(allCodeList[code.typeCode] instanceof Array) ){
                allCodeList[code.typeCode] = []
              }
              allCodeList[code.typeCode].push(code)
            }
            commit('SET_CODES', allCodeList)

            config.orderStatusList = allCodeList['order_status']
            config.transportTypeList = allCodeList['basic_transport_type']
            config.paymentTypeList = allCodeList['basic_payment_type']


            const OrderStatus = {}
            config.orderStatusList.map(function (e, item) {
              OrderStatus[e.code] = e.value;
            });
            config.OrderStatus = OrderStatus


            const TransportType = {}
            config.transportTypeList.map(function (e, item) {
              TransportType[e.code] = e.value;
            });
            config.TransportType = TransportType


            const PaymentType = {}
            config.paymentTypeList.map(function (e, item) {
              PaymentType[e.code] = e.value;
            });
            config.PaymentType = PaymentType
            // 单价是否关联客户开关处理
            /* if (response.data.priceLinkBusiness == "1") {
             config.priceLinkBusiness = true
             } else {
             config.priceLinkBusiness = false
             }*/

            // 黑名单处理
            // 黑名单开关处理
            if (response.data.blackListOpen == "1") {
              userConfig.blackListOpen = true
            } else {
              userConfig.blackListOpen = false
            }
            if (userConfig.blackListOpen == true) {
              // 黑名单集合处理
              const blackListOld = response.data.blackList
              let blackList = {}
              blackListOld.forEach(obj => {
                if (obj) {
                  if (!blackList[obj.type])
                    blackList[obj.type] = {}
                  blackList[obj.type][obj.recordId] = obj
                }
              });
              commit('SET_BLACK', blackList)
            }
            // 系统设置
            userConfig.settingsLlist = response.data.settingsLlist


            let allUserList = []
            let userList = response.data.userList
            for (let i=0;i<userList.length;i++){
              let code = userList[i]

              allUserList[code.id] = code.username

            }

            commit('SET_USERLIST', allUserList)

          }

          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },


  }
}

export default user
